import * as React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

export default class NewPageInputComponent extends React.Component<any, any> {

    constructor(props:any) {
        super(props);

        this.state = {
            addPageInput: "",
        }

        this.onPageInputChange = this.onPageInputChange.bind(this);
        this.addNewPage = this.addNewPage.bind(this);
    }

    private addNewPage(e:any) {
        e.preventDefault();
        this.props.addNewPage(this.state.addPageInput)
        this.setState({addPageInput: ""})
    }

    private onPageInputChange(event) {
        this.setState({addPageInput: event.target.value});
    }

    render() {
        return (
            <form onSubmit={this.addNewPage}>
                <FormGroup
                    controlId="formBasicText"
                    >
                    <FormControl
                        value={this.state.addPageInput}
                        className="addPageInput"
                        type="text"
                        onChange={this.onPageInputChange} 
                        placeholder="Type here to add a new page"
                    />
                </FormGroup>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/NewPageInputComponent.tsx